import { render, staticRenderFns } from "./ActualizaAspiranteDialogComponent.vue?vue&type=template&id=86b9ae26"
import script from "./ActualizaAspiranteDialogComponent.vue?vue&type=script&lang=js"
export * from "./ActualizaAspiranteDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports